/**
 * 서버 저장 실패를 사람에게 알린다 — 화면 컴포넌트 밖(api·config 모듈)에서도 부를 수 있게 창 이벤트로 낸다.
 * ToastProvider 가 받아 빨간 알림으로 띄운다.
 *
 * 2026-10-02(저장 최종점검 S4): 단가표·정산 서류·초안검수는 브라우저에 먼저 적고 서버로는 뒤에서 보내는데,
 * 실패를 `.catch(() => {})` 로 삼켜서 «저장된 것처럼» 보이다가 새로고침하면 사라졌다(확인 창 취소·권한 없음 포함).
 * 404 는 «서버가 아직 이 기능을 모른다(배포 전)»는 뜻이라 알리지 않는다 — 예전처럼 브라우저만 쓴다.
 */
export const SAVE_FAILED_EVENT = 'blb:save-failed';

/** 같은 실패가 연달아 나면 한 번만 — 칸을 여러 개 고치면 요청이 여러 번 나간다 */
const DEDUPE_MS = 3000;
let last = { key: '', at: 0 };

/** 이 오류를 알려야 하나 — 배포 전(404)이면 조용히 */
export const shouldNotify = (error) => error?.response?.status !== 404;

/** 사람이 읽을 이유 한 줄 */
export const reasonOf = (error) => {
  if (error?.isCriticalCancel) return '확인 창을 취소해';
  const status = error?.response?.status;
  if (status === 403) return '권한이 없어';
  if (status === 401) return '로그인이 끊겨';
  if (status === 428) return '변경 확인이 없어';
  if (!error?.response) return '서버에 닿지 않아';
  return '서버 오류로';
};

/**
 * @param {string} what   무엇을 저장하려 했나 (예: '요금표')
 * @param {any}    error  axios 오류
 * @param {string} [after] 덧붙일 안내 (예: '이 화면의 값은 저장 전으로 되돌렸습니다')
 * @returns {boolean} 알렸으면 true
 */
export function notifySaveFailure(what, error, after = '') {
  if (!shouldNotify(error)) return false;
  const message = `${what}이(가) ${reasonOf(error)} 서버에 저장되지 않았습니다.${after ? ` ${after}` : ''}`;
  const now = Date.now();
  if (last.key === message && now - last.at < DEDUPE_MS) return false;
  last = { key: message, at: now };
  try {
    window.dispatchEvent(new CustomEvent(SAVE_FAILED_EVENT, { detail: { message } }));
  } catch { /* 창이 없는 환경(시험) — 알림만 못 띄운다 */ }
  return true;
}

/** 시험용 — 중복 막기 기억을 비운다 */
export const __resetSaveFailureNotice = () => { last = { key: '', at: 0 }; };
